// extracted by mini-css-extract-plugin
export var indeterminate = "_45-5";
export var md = "_45-4";
export var semantic = "_45-6";
export var sm = "_45-3";
export var text = "_45-7";
export var toggleInput = "_45-0";
export var toggleSwitch = "_45-1";
export var xs = "_45-2";